<template>
  <router-link v-if="routerName" :to="{name: routerName}" class="btn-help" :class="[variant, size]" @click="clickHandler">
    <slot></slot>
  </router-link>
  <a v-else-if="href" :href="href" class="btn-help" :class="[variant, size]" @click="clickHandler">
    <slot></slot>
  </a>
  <button v-else class="text btn-help" :class="[variant, size]" @click="clickHandler">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'btn-help',
  props: ['variant', 'size', 'routerName', 'href'],
  methods: {
    clickHandler: function (e) {
      this.$emit('click', e)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.btn-help {
  display: inline-block;
  width: 130px;
  max-width: 100%;
  text-align: center;
  padding: 7px 0px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 14px;
  background-color: $dark;
  color: $white;
  @include mq-up(md) {
    border-radius: 30px;
    font-size: 16px;
    line-height: 16px;
    padding: 10px 0px;
  }
  &:hover {
    background-color: rgba($dark,0.8);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/button/BtnHelp.vue